const CURRENT_VERSION = import.meta.env.VITE_APP_VERSION;

const isOfflineGamesWorker = (registration) =>
    /\/sw\.js$/.test((registration.active || registration.waiting || registration.installing)?.scriptURL || '');

export async function checkVersionAndReload() {
    try {
        const res = await fetch('/version.json?t=' + Date.now(), { cache: 'no-store' });
        if (!res.ok) return;
        const { version } = await res.json();
        if (version && version !== CURRENT_VERSION) {
            const url = new URL(window.location.href);

            if (url.searchParams.get('v') === version) {
                return;
            }

            if ('serviceWorker' in navigator) {
                const registrations = await navigator.serviceWorker.getRegistrations();
                // The offline-games worker (/sw.js) loads pages network-first, so it never serves
                // a stale build; it's updated rather than removed so downloaded games keep working.
                await Promise.all(registrations.map((registration) => (isOfflineGamesWorker(registration) ? registration.update() : registration.unregister())));
            }

            if ('caches' in window) {
                const cacheNames = await caches.keys();
                // Downloaded offline games survive; the site copy is re-cached after the reload.
                await Promise.all(cacheNames.filter((cacheName) => !cacheName.startsWith('akedo-offline-games')).map((cacheName) => caches.delete(cacheName)));
            }

            url.searchParams.set('v', version);
            window.location.replace(url.toString());
        }
    } catch {
        // Network error — don't block app startup
    }
}
